module.exports = __webpack_public_path__ + "img/daka.e5d3699b.png";